<template>
    <div>
        <div id="contendor-principal-envioDeCedulas" class="container-fluid">
        <div class="container-fluid">
            <!-- NUEVO LAYOUT -->
            <div id="encabezados-tp">
                <h1>ENVÍO DE CÉDULAS</h1>
                <h3>Selcciona y envia una o mas cédulas a la dirección de notificadores</h3>
                <div class="hr-titulo"></div>
            </div>
            <div class="row" style="margin-top: 3em;">
                <!-- SECCION PARA LOS FILTROS DE BUSQUEDA -->
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pb-4">
                    <div class="card">
                        <div class="card-header">
                            <h5><strong>Filtros de búsqueda</strong></h5>
                        </div>
                        <div class="card-body">
                            <FiltrosDeBusqueda
                                :posicionHorizontal="true"
                                :conSwitchHabilitacion="true"
                                :catalogos="filtrosDeBusqueda" 
                                :ejecutaLaFuncion="obtenerCedulasParaEnvio" 
                                :filtrosEstablecidos="filtrosEstablecidos"
                                :tituloDeBusqueda="''"
                                v-on:cambioTipoDeDocumento="evtCambioTipoDocumento"
                                v-on:cambioDeArea="evtCambioJuzgado"
                                v-on:cambioTipoDeCedula="evtCambioTipoCedula"
                                v-on:AccionEnSwitchDeFiltros="evtAccionEnSwitchDeFiltros"
                                :ref="REF_FILTROS_BUSQUEDA"></FiltrosDeBusqueda>
                        </div>
                    </div>
                </div>
                <!-- SECCION  LISTADO DE CEDULAS -->
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pb-4">
                    <div class="card">
                        <div class="card-header">
                            <div class="form-inline justify-content-between flex-wrap">
                                <h5><strong>Cédulas encontradas&nbsp;&nbsp;&nbsp;[ {{ this.cedulasParaEnvioBD.length }} ]</strong></h5>
                                <div id="inputs-filtro-memoria" class="form-inline">
                                    <input v-model="tablaCedulas.buscarPor" type="text" id="f-busqueda" placeholder="Buscar en todas las columnas" class="form-control"/>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div v-show="!cargandoCedulas">
                                <div v-if="cedulasEnvioAJuzgado.some(c => c.enviar)" class="form-inline flex-wrap mb-2" style="gap: 0.5em !important;">
                                    <h6><strong><i class="fas fa-check-square"></i>&nbsp;&nbsp;Cédulas: {{ cedulasEnvioAJuzgado.filter(c => c.enviar).length }}</strong></h6>
                                    <button type="button" class="btn btn-primary texto-ajustable" @click="accionesModal({ id: 'visualizador-fecha-envio-opciones', accion: 'show' })"><i class="fas fa-paper-plane"></i>&nbsp;&nbsp;Enviar Cédulas</button>
                                </div>
                                <CTablaGenericaCedulas class="table-responsive"
                                    :idDelInput="ID_TABLA_CEDULAS_ENCONTRADAS"
                                    :encabezadosColumnas="encabezadosColumnas"
                                    :accionesEnTabla="TABLA_CEDULAS_SELECCIONADA_ACCIONES"
                                    :listaDeCedulas="cedulasParaEnvioTabla"
                                    :resaltarFila="resaltarFilaProp" 
                                    :conResponsive="true"
                                    v-on:elementosSeleccionados="evtObtenerCedulasSeleccionadas"
                                    :ref="tablaCedulas.REF_TABLA_CEDULAS"></CTablaGenericaCedulas>
                            </div>
                            <div v-if="cargandoCedulas" class="contenedor-cargando" style="height: 300px ;">
                                <div class="text-center">
                                    <i class="fas fa-spinner fa-spin fa-5x"></i>
                                    <h4 class="mt-4">Cargando cédulas</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- MODAL CON VISUALIZADOR DE REPORTE -->
            <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visualizador-reporte-envioJuzgado">
                <div class="modal-dialog modal-lg modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Reporte cedulas enviadas</h5>
                            <button id="btn-cerrar-visualizador-reporte-envioJuzgado" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                        </div>
                        <div class="modal-body pl-4 pr-4">
                            <PDFDocument 
                                :url="visualizadorDelReporte.url" 
                                :ArchivoAConvertir="visualizadorDelReporte.archivoDeReporte"
                                :EsBase64="EsBase64"
                                :EsBlob = "EsBlob" 
                                :height="visualizadorDelReporte.height"
                                :key="'VDRCEJZDDIR' + visualizadorDelReporte.contRender" />
                        </div>             
                    </div>
                </div>
            </div>
            <!-- MODAL PARA LA SELECCION DE LA FECHA DE ENVIO -->
            <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visualizador-fecha-envio-opciones">
                <div class="modal-dialog modal-lg modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Datos de envio</h5>
                            <button id="btn-cerrar-visualizador-fecha-envio-opciones" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                        </div>
                        <div class="modal-body pl-4 pr-4">
                            <div class="form-group">
                                <h6>Fecha de envio</h6>
                                <input type="date" id="fechaDeInicio" v-model="envioOpciones.fecha" class="form-control" />
                            </div>
                            <div class="d-flex justify-content-end">
                                <button type="button" class="btn btn-success texto-ajustable" @click="iniciarProcesoDeEnvio"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                            </div>
                        </div>             
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div v-show="false" id="map"></div>
    </div>    
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import comun from "@/../static/js/comun"
import catalogos from '@/../static/js/catalogos'
import api from '@/../static/js/api'
import axios from 'axios'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'

export default {
    components: {
        PDFDocument: PDFDocument,
        FiltrosDeBusqueda: sistemas.SINOJ.FiltrosDeBusqueda,
        C001Area: catalogos.PJ.C001Area,
        CTablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas
    },
    data() {
        return {
            EsBase64:{
                esBase64:false,
                archivoBase64:null
            },
            EsBlob:{
             esBlob:false,
             blob:null},
            enumeraciones,
            ID_INPUT_JUZGADO_A_ENVIAR: 'catalogoJuzgadoAEnviarEnvioDeCedula',
            ID_TABLA_CEDULAS_ENCONTRADAS: 'tablaCedulasEnvioDeCedula',
            filtrosDeBusqueda: [
                { 
                    catalogoId: 'filtroNumeroFolio',
                    idDelInput: 'FNumFolioVECAD'
                },
                { 
                    catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione,
                    idDelInput: 'catalogoJuzgadoEnvioDeCedula'
                },
                { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'f-tMateria-VEDCD' },
                { 
                    catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione,
                    idDelInput: 'catalogoTipoDocumentoEnvioDeCedula'
                },
                { 
                    catalogoId: enumeraciones.sinoj.catalogos.TiposDeCedula, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione,
                    idDelInput: 'catalogoTipoDeCedulasAsignacion'
                },
                { catalogoId: enumeraciones.catalogos.FechaDeInicio },
                { catalogoId: enumeraciones.catalogos.FechaFinal },
                { 
                    catalogoId: 'filtroAreaEncargada', etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione,
                    idDelInput: 'catalogoJurisdiccionEnvioDeCedula'
                },
            ],
            REF_FILTROS_BUSQUEDA: 'RefFBVEDC',
            filtrosEstablecidos: {},
            /* parametros_Area: {
                key: "",
                areaId: -1,
                parametros: {}
            }, */
            encabezadosColumnas: ['Folio','Consecutivo', 'Juzgado','Tipo de documento','Tipo de cedula','Fecha audiencia','Persona a notificar','Estatus',''],
            TABLA_CEDULAS_SELECCIONADA_ACCIONES: {motrarAcciones: true,check: true, eliminar: false},
            listaDeCedulasEnviar: [],
            tipoDocumentoId: -1,
            tipoJuzgadoId: -1,
            tipoDeCedula: -1,
            cedulasEnvioAJuzgado: [],
            cedulasParaEnvioBD: [],
            cedulasParaEnvioTabla: [],
            cargandoCedulas: false,
            mesajeSinCedulas: 'No se ha realizado ninguna busqueda, en el paso 1 presione el boton de Buscar.',
            numeroCedulasAEnviar: 0,
            zonasBD: [],
            poligonosZonas: [],
            cargoAreaDeUsuario: false,
            FORMATO_FECHA: "DD/MM/YYYY HH:mm:ss",
            visualizadorDelReporte: {
                url: null,
                height: '500px',
                archivoDeReporte: null,
                contRender: 0
            },
            filtrosDeBusquedaSecciones: {
                expediente: true,
                cedula: true,
                fechas: true
            },
            tablaCedulas: {
                buscarPor: null,
                REF_TABLA_CEDULAS: 'ReftablaCedulasEnvioDeCedulaVEDCAD'
            },
            envioOpciones: {
                fecha: moment().format('YYYY-MM-DD')
            },
            resaltarFilaProp: {
                aplicarValidacion: true,
                validacion: (index, cedula) => {
                    let valor = Object.values(cedula);
                    const POSICION_COLUMNA_ESTATUS = 6;
                    const ESTATUS_A_RESALTAR = 'Regresada';
                    const SE_PUEDE_APLICAR_VALIDACION = (valor != null && valor != undefined && valor.length >= POSICION_COLUMNA_ESTATUS);
                    return (SE_PUEDE_APLICAR_VALIDACION && valor[POSICION_COLUMNA_ESTATUS] == ESTATUS_A_RESALTAR);
                }
            }
        }
    },
    methods: {
        filtrarCedulasTabla: function(e) {
            // filtra por columnas y nivel de prioridad
            this.cedulasParaEnvioTabla = this.darFormatoCedulasTabla(this.cedulasParaEnvioBD)
            .filter(c => {
                return Object.values(c).some(valorColumna => this.predicateFiltradoPorSimilitud(valorColumna, this.tablaCedulas.buscarPor));
            });
            this.persistirSeleccionDeCedulas();
        },
        predicateFiltradoPorSimilitud: function(elementoAEvaluar,compararCon) { 
            if(this.campoRequeridoEsValido(compararCon)) {
            if(elementoAEvaluar.toString().toUpperCase().startsWith(compararCon.toString().toUpperCase()))
                return true;
            else
                return false;
            }
            else
                return true;
        },
        persistirSeleccionDeCedulas: function() {
            this.$nextTick(() => { 
                this.cedulasEnvioAJuzgado.filter(c => c.enviar).forEach(cedulaSeleccionada => {
                    let cedulaEstaEnSelccionadas = this.cedulasParaEnvioTabla.some(c => c.Folio == cedulaSeleccionada.folio);
                    if(cedulaEstaEnSelccionadas)
                        this.$refs[this.tablaCedulas.REF_TABLA_CEDULAS].seleccionDeCedulaComponentePadre(cedulaSeleccionada.idCheck);
                });
                let tabla = this.$refs[this.tablaCedulas.REF_TABLA_CEDULAS];
                this.cedulasEnvioAJuzgado = this.$refs[this.tablaCedulas.REF_TABLA_CEDULAS].cedulasAEnviar;
            });
            console.log(this.cedulasEnvioAJuzgado);
        },
        evtAccionEnSwitchDeFiltros: function(accionRealizada) {
            switch(accionRealizada.tipoDeFiltro) {
                case 'Expediente':
                    this.filtrosDeBusquedaSecciones.expediente = accionRealizada.habilitar;
                    break;
                case 'Cedula':
                    this.filtrosDeBusquedaSecciones.cedula = accionRealizada.habilitar;
                    break;
                case 'Fechas':
                    this.filtrosDeBusquedaSecciones.fechas = accionRealizada.habilitar;
                    break;
                default:
                    break;
            };
        },
        informarConfirmacionGenracionDeReporte: function (solicitudCedulasReporte) {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: `Las cédulas se enviaron correctamente<br><br>Deseas generar el reporte de las cédulas enviadas a dirección<br>`,
                buttons: {
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si'
                    },
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No&nbsp;&nbsp;&nbsp;&nbsp;'
                    }
                },
                callback: async (respuesta) => {
                    if (respuesta) {
                        console.log('solicitudCedulasReporte::',solicitudCedulasReporte);
                        let peticionAPI = await Promise.resolve(this.crearPeticionParaReporteCedulasEnviadas(solicitudCedulasReporte));
                        this.evtCreacionDeReporte(peticionAPI);
                    }
                }
            });
        },
        crearPeticionParaReporteCedulasEnviadas: async function(cedulasEnviadas) { 
            let peticionReporte = [];
            cedulasEnviadas.forEach(ce => {
                if(peticionReporte.length < 1) {
                    const OBJ_SOLICITUD_REPORTE = {
                        indentificadorSolicitud: ce.Expediente.Juzgado.JuzgadoId + moment(ce.FechaDeEnvio).format('DD-MM-YYYY'),
                        id: ce.Expediente.Juzgado.JuzgadoId,
                        juzgado: ce.Expediente.Juzgado.Nombre,
                        fechaReporte: ce.FechaDeEnvio
                    };
                    peticionReporte.push(OBJ_SOLICITUD_REPORTE);
                }
            });
            return peticionReporte;
        },
        evtCreacionDeReporte: function(peticionAPI) {
            /*let peticion = new FormData();
            peticion.append('EsPrueba',false);
            peticion.append('SolicitudesDeReportes',JSON.stringify(peticionAPI));
            peticion.append('conInformacionCompletaDeCedulas',false);*/
            let peticion = {};
            peticion.EsPrueba = false;
            peticion.SolicitudesDeReportes = JSON.stringify(peticionAPI);        
            peticion.conInformacionCompletaDeCedulas = false;
            
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.sistema.reportes.reporteDeJuzgado.ObtenerReporteDeJuzgado;
            let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionArchivos = true;
            this.visualizarReporte = false;
            //let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,true);
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticion, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            const ARCHIVO_DESCARGADO = respuesta.data;
                            //if(ARCHIVO_DESCARGADO != null && ARCHIVO_DESCARGADO.byteLength > 0) {
                            if(respuesta.data.ArchivoBase64 != null) {
                                //this.visualizadorDelReporte.archivoDeReporte = new File([ARCHIVO_DESCARGADO], 'ReporteCedulasEnviadasAJuzgado', { type: 'application/pdf' });                                
                                this.visualizarReporte = true;
                                this.EsBase64={
                                  esBase64:true,
                                  archivoBase64:respuesta.data.ArchivoBase64
                                }
                                this.visualizadorDelReporte.contRender ++;
                                comun.SeEstaCargandoInformacion(false);
                                $('#visualizador-reporte-envioJuzgado').modal('show');
                            }
                            else
                                comun.mensajeDeAlerta('No se encontro información con los parámetros  ingresados en las solicitudes de reporte');
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        evtDistanciaMinima: async function() {
            /* let resultado = await this.evtEncontrarZonaAsignar();
            let valor = Math.min.apply(null, [resultado]);
            console.log('distanciaaync::',valor); */
            //this.perteneceAlPolygono2();
            let peticion = await Promise.resolve(this.crearPeticionParaEnviarCedulas());
            //console.log('peticion::cedula::',peticion.Cedulas);
        },
        accionesModal: function({ id, accion }) {
            $('#' + id).modal(accion);
        },
        iniciarProcesoDeEnvio: async function() {
            const { fecha } = this.envioOpciones;
            if(this.campoRequeridoEsValido(fecha)) {
                 this.accionesModal({ id: 'visualizador-fecha-envio-opciones', accion: 'hide' });
                await Promise.resolve(this.evtEnviarCedulas());
            }
            else {
                comun.mensajeDeAlerta('La fecha no puede estar vacia');
            }
        },
        evtEnviarCedulas: async function() {
            let peticion = await Promise.resolve(this.crearPeticionParaEnviarCedulas());
            this.enviarCedulasAJuzgadoBD(peticion);
        },
        crearPeticionParaEnviarCedulas: async function() { 
            let peticion = {};
            let cedulasEnvio = this.cedulasEnvioAJuzgado.filter(ce => ce.enviar);
            let cedulas = [];
            for(let c of cedulasEnvio) { 
                let datosCedula = this.cedulasParaEnvioBD.find(cbd => cbd.CedulaId == c.folio);
                let cedula = {};
                cedula.CedulaId = c.folio;
                cedula.FechaDeEnvio = this.envioOpciones.fecha;
                //console.log('crearPeticionParaEnviarCedulas::',datosCedula);
                if(this.campoRequeridoEsValido(datosCedula)) {
                    const ES_JUZGADO_MIXTO = this.esJuzgadoMixto(this.$store.state.Login_Usuario.Area);
                    /* codigo funcional antes de modificacion mixtos jesus maria
                    if(!ES_JUZGADO_MIXTO) {
                        // valida si el notificador ya tiene asignacion desde la creacion de la cedula si no realiza la asignacion
                        cedula.Notificador = this.campoRequeridoEsValido(datosCedula.Notificador)
                            ? { NotificadorId: datosCedula.Notificador.NotificadorId, 
                                Usuario: { IdUsuario: datosCedula.Notificador.Usuario.IdUsuario } } 
                            : await Promise.resolve(this.asignarNotificador(datosCedula));
                    }
                    else {
                        cedula.Notificador = null;
                    }*/

                    cedula.Notificador = this.campoRequeridoEsValido(datosCedula.Notificador)
                            ? { NotificadorId: datosCedula.Notificador.NotificadorId, 
                                Usuario: { IdUsuario: datosCedula.Notificador.Usuario.IdUsuario } } 
                            : await Promise.resolve(this.asignarNotificador(datosCedula));
                }
                cedulas.push(cedula)
            }
            peticion.Cedulas = cedulas;
            /* peticion.Cedulas = this.cedulasEnvioAJuzgado.filter(ce => ce.enviar).map((c) => {
                let datosCedula = this.cedulasParaEnvioBD.find(cbd => cbd.CedulaId == c.folio);
                let cedula = {};
                cedula.CedulaId = c.folio;
                cedula.Notificador = this.campoRequeridoEsValido(datosCedula) ? await Promise.resolve(this.asignarNotificador(datosCedula)) : null
                return cedula;
            }); */
            peticion.esPrueba = false;
            return peticion;
        },
        asignarNotificador: async function(cedula) { debugger
            //console.log('asignarNotificador::cedula::',cedula);
            let notificadorAsignado = null;
            let { PersonasANotificar } = cedula;
            let coordenadaDomicilio = null;

            // caso donde es un fraccionamiento fuera del catalogo se deja sin asignacion
            if(this.campoRequeridoEsValido(PersonasANotificar) && this.campoRequeridoEsValido(PersonasANotificar[0].Domicilios)) {
                let domicilio = PersonasANotificar[0].Domicilios[0];
                if(!this.campoRequeridoEsValido(domicilio.Fraccionamiento)) {
                    return notificadorAsignado;
                }
            }
    
            // caso de tener algun notificador el fraccionamiento asignado del domicilio
            if(this.campoRequeridoEsValido(PersonasANotificar) && this.campoRequeridoEsValido(PersonasANotificar[0].Domicilios)) {
                let domicilio = PersonasANotificar[0].Domicilios[0];
                if(this.campoRequeridoEsValido(domicilio.Fraccionamiento) && this.campoRequeridoEsValido(domicilio.Fraccionamiento.NotificadoresAsignados)) {
                    let notificadorObj = domicilio.Fraccionamiento.NotificadoresAsignados[0].Notificador;
                    if(this.campoRequeridoEsValido(notificadorObj))
                        return notificadorObj
                }
            }

            // valida que tenga una persona a notificar, la personas tenaga un domicilio y el doicilio tenga coordenadas de localizacion
            if(this.campoRequeridoEsValido(PersonasANotificar)) {
                coordenadaDomicilio = (this.campoRequeridoEsValido(PersonasANotificar[0].Domicilios)) ? 
                    this.campoRequeridoEsValido(PersonasANotificar[0].Domicilios[0].Coordenadas) ?
                        [ PersonasANotificar[0].Domicilios[0].Coordenadas[0].Latitud, PersonasANotificar[0].Domicilios[0].Coordenadas[0].Longitud ]
                        : null
                    : null;
            }
            //console.log('asignarNotificador::coordenadaDomicilio::',coordenadaDomicilio);
            // valida que sea un domicilio valido(con coordenadas) y que alguna de ls zonas tenga notififcadores asignados
            console.log('paso1::',coordenadaDomicilio)
            console.log('paso1zonas::',this.zonasBD)
            if(this.campoRequeridoEsValido(coordenadaDomicilio) && this.zonasBD.some(z => z.Notificadores != null && z.Notificadores.length > 0)) {
                notificadorAsignado = await this.domicilioEstaDentroDeZona(coordenadaDomicilio); console.log('domicilioEstaDentroDeZona::',notificadorAsignado);
                //console.log('asignarNotificador::MZonaCerc::',notificadorAsignado);
                // si no esta dentro de alguna zona encuentra la zona mas cercana para la asignacion
                /* if(!this.campoRequeridoEsValido(notificadorAsignado)) 
                    notificadorAsignado = await this.encontrarZonaMasCercana(coordenadaDomicilio);console.log('entro-encontrarZonaMasCercana::',notificadorAsignado); */
            }
            //console.log('asignarNotificador::',notificadorAsignado);
            console.log('paso2::',notificadorAsignado);
            return notificadorAsignado;
        },
        domicilioEstaDentroDeZona: async function(coordenaDomicilio) { 
            //console.log('domicilioEstaDentroDeZona::cordDom::',coordenaDomicilio);
            return new Promise((resolve, reject) => {
                // se compara con cada uno de los poligonos de las zonas (poligonosZonas) y tenga notificadores la zona
                let notificador = null;
                let poligonosConNotificadores = this.poligonosZonas.filter(pz => this.zonasBD.some(zBD => (zBD.Notificadores != null && zBD.Notificadores.length > 0) && zBD.ZonaId == pz.zona));
                    for(let p of poligonosConNotificadores) {
                    // se crea el array de coordenadas con los verices de las areas de las zonas
                    let coordenadasPoligono = p.coordenadas.map(pc => {
                        let coordenada = { lat: pc[0], lng: pc[1] }
                        return coordenada;
                    });
                    let polygono = { coordenadas: coordenadasPoligono};
                   // console.log('domicilioEstaDentroDeZona::cordPolygono::',polygono);
                    // verifica si la coordenada del domicilio esta dentro de la zona
                    let puntoDeBusqueda = { lat: coordenaDomicilio[0], lng: coordenaDomicilio[1] };
                    let perteneceAPolygono = this.lugarSeEncuentraEnPolygono(puntoDeBusqueda,polygono);
                    //console.log('domicilioEstaDentroDeZona::dentroDePoligono::',perteneceAPolygono);
                    if(perteneceAPolygono) {
                        // busca todos los datos de la zona
                        let zonaDeNotificador = this.zonasBD.find(z => z.ZonaId == p.zona);
                        notificador = {
                            // definir logica de balanceo de carga
                            NotificadorId: zonaDeNotificador.Notificadores[0].NotificadorId,
                            Usuario: {
                                IdUsuario: zonaDeNotificador.Notificadores[0].Usuario.IdUsuario
                            }
                        }
                        //console.log('domicilioEstaDentroDeZona::notificador::',notificador);
                        break;
                    }
                }
                resolve(notificador);
            });
        },
        lugarSeEncuentraEnPolygono: function(marcador, polygono) {
            let puntoDePolygono = polygono.coordenadas;       
            let x = marcador.lat; 
            let y = marcador.lng;
            //console.log('puntoDePolygono::',puntoDePolygono);
            //console.log('x::' + x);
            //console.log('y::' + y);

            let seEncuentraDentro = false;
            for (let i = 0, j = puntoDePolygono.length - 1; i < puntoDePolygono.length; j = i++) {
                let xi = puntoDePolygono[i].lat, yi = puntoDePolygono[i].lng;
                let xj = puntoDePolygono[j].lat, yj = puntoDePolygono[j].lng;

                let interseccion = ((yi > y) != (yj > y))
                    && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
                if (interseccion) seEncuentraDentro = !seEncuentraDentro;
            }
            return seEncuentraDentro;
        },
        /* encontrarZonaMasCercana: async function(coordenadaDomicilio) { 
            // se compara con cada uno de los poligonos de las zonas (poligonosZonas) y tenga notificadores la zona
            let distanciasZonasADomicilio = []; 
            let poligonos = this.poligonosZonas.filter(pz => this.zonasBD.some(zBD => (zBD.Notificadores != null && zBD.Notificadores.length > 0) && zBD.ZonaId == pz.zona));
            // for normal para no hacer un foreach asincrono
            for(let i=0; i<poligonos.length; i++) {
                let poligonoDeZona = poligonos[i].coordenadas;
                let distanciaMinima = await this.evtEncontrarDistanciaMasCorta(poligonoDeZona, coordenadaDomicilio);
                let datosDistancia = { zonaId: poligonos[i].zona, distancia: Math.min.apply(null, [distanciaMinima]) };
                //console.log('encontrarZonaMasCercana::obj::Zona::',datosDistancia,'::',poligonoDeZona);
                distanciasZonasADomicilio.push(datosDistancia);
            }
            //console.log('encontrarZonaMasCercana::distancias::',distanciasZonasADomicilio);
            if(distanciasZonasADomicilio.length > 0) {
                let dMin = null;
                // si es hay una distancia con valor 0 es que esta muy cerca significa que es la mas cercana si que busque el valor menor
                if(distanciasZonasADomicilio.some(dzm => dzm.distancia == 0)) {
                    dMin = distanciasZonasADomicilio.find(dzm => dzm.distancia == 0).distancia;
                }
                else {
                    dMin = Math.min.apply(null,distanciasZonasADomicilio.map(d => {
                        return d.distancia
                    }));    
                }
                //console.log('encontrarZonaMasCercana::distanciaMinima::',dMin);
                let zonaMasCercana = distanciasZonasADomicilio.find(dz => dz.distancia == dMin);
                //console.log('encontrarZonaMasCercana::zonaMasCercana::',zonaMasCercana);
                let zonaDeNotificador = this.zonasBD.find(z => z.ZonaId == zonaMasCercana.zonaId);
                let notificador = {
                    // definir logica de balanceo de carga
                    NotificadorId: zonaDeNotificador.Notificadores[0].NotificadorId,
                    Usuario: {
                        IdUsuario: zonaDeNotificador.Notificadores[0].Usuario.IdUsuario
                    }
                }
                return notificador;
            }
            return null;
        },
        vlen: function(vector) {
            return Math.sqrt(vector[0]*vector[0] + vector[1] * vector[1]);
        },
        vsub: function(v1, v2) {
            return [v1[0] - v2[0], v1[1] - v2[1]];
        },
        vscale: function(vector, factor) {
            return [vector[0] * factor, vector[1] * factor];
        },
        vnorm: function(v) {
            return [-v[1], v[0]];
        },
        evtEncontrarDistanciaMasCorta: async function(zona, domicilio) {
          const distanciaMinina = new Promise((resolve, reject) => {
              let poly = zona;
              let point = domicilio;
              var dists = poly.map((p1, i) => {
                var prev = (i == 0 ? poly.length : i) - 1,
                    p2 = poly[prev],
                    line = this.vsub(p2, p1);

                    if (this.vlen(line) == 0)
                        resolve(this.vlen(vsub(point, p1)));

                    var norm = this.vnorm(line),
                        x1 = point[0],
                        x2 = norm[0],
                        x3 = p1[0],
                        x4 = line[0],
                        y1 = point[1],
                        y2 = norm[1],
                        y3 = p1[1],
                        y4 = line[1],

                        j = (x3 - x1 - x2 * y3 / y2 + x2 * y1 / y2) / (x2 * y4 / y2 - x4),
                        i;

                    if (j < 0 || j > 1)
                        resolve(Math.min(
                        this.vlen(this.vsub(point, p1)),
                        this.vlen(this.vsub(point, p2))));

                    i = (y3 + j * y4 - y1) / y2;

                    resolve(this.vlen(this.vscale(norm, i)));
              });
          }); 
          return distanciaMinina;
        }, */
        enviarCedulasAJuzgadoBD: function(peticionAPI) {
            //console.log('enviarCedulasAJuzgadoBD::peticion::',peticionAPI);
            const SERVIDOR = api.conexion;
            const METODO_API_ENVIAR = api.SINOJ.sistema.cedulas.envio.EnviarCedulasAJuzgado;
            let urlApi = SERVIDOR + METODO_API_ENVIAR;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            this.cargandoCedulas = true;
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(respuesta.data.Error);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            //console.log("enviarCedulasAJuzgadoBD::ejecuto bien:: ",respuesta.data);
                            // Elimina las cedulas que se enviaron de las cedula cargadas previamente en memoria
                            this.cedulasParaEnvioBD = this.cedulasParaEnvioBD.filter(cbd => {
                                return !peticionAPI.Cedulas.some(c => c.CedulaId == cbd.CedulaId);
                            });
                            this.cedulasParaEnvioTabla = this.darFormatoCedulasTabla(this.cedulasParaEnvioBD);
                            // se limpia la lista de cedulasAEnviar
                            this.cedulasEnvioAJuzgado = [];
                            comun.SeEstaCargandoInformacion(false);
                            //comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                            this.informarConfirmacionGenracionDeReporte(respuesta.data.Cedulas);
                        }
                        this.cargandoCedulas = false;
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        this.cargandoCedulas = false;
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        evtObtenerCedulasSeleccionadas: function(evento) {
            this.cedulasEnvioAJuzgado = evento.filter(c => c.enviar);
            this.numeroCedulasAEnviar = this.cedulasEnvioAJuzgado.filter(c => c.enviar).length;
        },
        evtCambioTipoDocumento: function(evento) {
            const TIPO_DOCUMENTO_ID = parseInt(evento.target.value);
            this.tipoDocumentoId = (TIPO_DOCUMENTO_ID > 0) ? TIPO_DOCUMENTO_ID : -1;
        },
        evtCambioJuzgado: function(evento) {
            const TIPO_JUZGADO_ID = parseInt(evento.target.value);
            this.tipoJuzgadoId = (TIPO_JUZGADO_ID > 0) ? TIPO_JUZGADO_ID : -1;
        },
        evtCambioTipoCedula: function(evento) {
            const TIPO_CEDULA_ID = parseInt(evento.target.value);
            this.tipoDeCedula = (TIPO_CEDULA_ID > 0) ? TIPO_CEDULA_ID : -1;
        },
        obtenerCedulasParaEnvio: function() {
           /* let hayCedulasSeleccionadas = this.cedulasEnvioAJuzgado.some(c => c.enviar);
           this.mesajeSinCedulas = (this.mesajeSinCedulas != 'No se encontraron cedulas') ? 'No se encontraron cedulas' : this.mesajeSinCedulas;
           if(hayCedulasSeleccionadas)
              this.confirmacionPerdidaCedulasSeleccionadas();
           else
              this.obtenerCedulasParaEnvioBD(); */
            this.obtenerCedulasParaEnvioBD();
        },
        /* cambiarDeCedula: function() {
            console.log('cambiarListado::',this.listaDeCedulas);
            this.listaDeCedulas = this.listaDeCedulas2;
            console.log('cambiarListado::',this.listaDeCedulas);
        },
        cambioDeArea: function() {

        } */
        obtenerCedulasParaEnvioBD: function() { 
           const SERVIDOR = api.conexion;
           const METODO_API_OBTENER = api.SINOJ.sistema.cedulas.envio.ObtenerCedulasParaEnvioAJuzgado;
           let urlApi = SERVIDOR + METODO_API_OBTENER;
           console.log('sw::',this.filtrosDeBusquedaSecciones.expediente)
           let peticionAPI = {
                Folio: (this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].numeroDeFolio) && this.filtrosDeBusquedaSecciones.cedula) ? this.$refs[this.REF_FILTROS_BUSQUEDA].numeroDeFolio : null,
                JuzgadoId: (this.tipoJuzgadoId < 0) ? null : this.tipoJuzgadoId,
                MateriaId: (this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Materia.materiaId) && this.filtrosDeBusquedaSecciones.expediente) ? this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Materia.materiaId : null,
                TipoDocumentoId: (this.tipoDocumentoId < 0 || !this.filtrosDeBusquedaSecciones.expediente) ? null : this.tipoDocumentoId,
                Consecutivo: this.campoRequeridoEsValido(parseInt(this.$refs[this.REF_FILTROS_BUSQUEDA].numeroExtra)) && this.filtrosDeBusquedaSecciones.expediente ? parseInt(this.$refs[this.REF_FILTROS_BUSQUEDA].numeroExtra) : null,
                TipoCedulaId: (this.tipoDeCedula < 0 || !this.filtrosDeBusquedaSecciones.cedula) ? null : this.tipoDeCedula,
                Jurisdiccion: (this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area_Encargada.areaEncargadaId) && this.filtrosDeBusquedaSecciones.cedula) ? this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area_Encargada.areaEncargadaId : null,
                FechaInicial: (this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].fechaInicial) && this.filtrosDeBusquedaSecciones.fechas) ? this.$refs[this.REF_FILTROS_BUSQUEDA].fechaInicial : null,
                FechaFinal: (this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].fechaFinal) && this.filtrosDeBusquedaSecciones.fechas) ? this.$refs[this.REF_FILTROS_BUSQUEDA].fechaFinal : null
            };
            peticionAPI.esPrueba = false;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            this.cargandoCedulas = true;
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(respuesta.data);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            //console.log("obtenerCedulasParaEnvioBD::ejecuto bien:: ",respuesta.data);
                            this.cedulasParaEnvioBD = (respuesta.data.Cedulas != null) ? respuesta.data.Cedulas : [];
                            this.cedulasParaEnvioTabla = this.darFormatoCedulasTabla(this.cedulasParaEnvioBD);

                            if(respuesta.data.Cedulas != null && respuesta.data.Cedulas.length > 0) {
                                // se persiste las cedulas seleccionadas
                                this.persistirSeleccionDeCedulas();
                                
                                //se agrega eventos para el filtro de busqueda en memoria de la tabla
                                $("#inputs-filtro-memoria input").on("change paste keyup", (e) => {
                                    if(this.cedulasParaEnvioBD.length > 0) {
                                        this.filtrarCedulasTabla(e);
                                    }
                                });
                            }
                            else {
                                this.cedulasEnvioAJuzgado = [];
                            }
                        }
                        this.cargandoCedulas = false;
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        this.cargandoCedulas = false;
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
         /**
         * Metodo encargado de dar formato a objetos de cedula al formato
         * [Folio',Fecha de Registro,Tipo de cedula,Estatus] que ocupa la
         * tabla de la vista. 
         * @param {object} cedulas [fuente de datos de cedulas]
         * @see {@link cedulaAObjetoTabla}
         */
        darFormatoCedulasTabla: function(cedulas) {
            let cedulasConFormato = [];
            cedulasConFormato = cedulas.map(c => {
                let cedula = this.cedulaAObjetoTabla(c);
                return cedula;
            });
            return cedulasConFormato;
        },
        cedulaAObjetoTabla: function(cedula) { 
            console.log('------------------revcedulaAObjetoTabla::',cedula);
            let cedulaObjTabla = {};
            cedulaObjTabla.Folio = cedula.CedulaId;
            cedulaObjTabla.Consecutivo = 'Sin consecutivo';
            cedulaObjTabla.Juzgado = 'Sin juzgado';
            cedulaObjTabla.TipoDocumento = 'Sin documento';
            if(this.campoRequeridoEsValido(cedula.Expediente)) { 
                cedulaObjTabla.Consecutivo = cedula.Expediente.NumeroDeDocumento;
                cedulaObjTabla.Juzgado = (cedula.Expediente.Juzgado != null ) ? cedula.Expediente.Juzgado.Nombre : 'Sin juzgado';
                cedulaObjTabla.TipoDocumento = (cedula.Expediente.TipoDocumento != null) ? cedula.Expediente.TipoDocumento.Nombre : 'Sin documento';
            }
            /* cedulaObjTabla.estatus = cedula.Resultado.TipoResultado.Nombre; */
            cedulaObjTabla.TipoCedula = this.campoRequeridoEsValido(cedula.TipoCedula.Nombre) ? cedula.TipoCedula.Nombre.trim() : 'Sin tipo de cedula.';
            cedulaObjTabla.FechaAudiencia = 'Sin fecha de audiencia'
            /* if(this.campoRequeridoEsValido(cedula.Expediente)) {
                if(cedula.Expediente.Acuerdos != null && cedula.Expediente.Acuerdos.length > 0) {
                    let acuerdoPrincipal = cedula.Expediente.Acuerdos.find(a => a.EsPrincipal);
                    if(acuerdoPrincipal != null && acuerdoPrincipal != undefined) {
                        cedulaObjTabla.FechaAudiencia = this.campoRequeridoEsValido(acuerdoPrincipal.FechaDeAudiencia) ? moment(acuerdoPrincipal.FechaDeAudiencia).format(this.FORMATO_FECHA) : 'Sin fecha de audiencia';
                    }
                }
            } */
            if(cedula.Acuerdos != null && cedula.Acuerdos.length > 0) {
                let acuerdoPrincipal = cedula.Acuerdos.find(a => a.EsPrincipal);
                if(acuerdoPrincipal != null && acuerdoPrincipal != undefined) {
                    cedulaObjTabla.FechaAudiencia = this.campoRequeridoEsValido(acuerdoPrincipal.FechaDeAudiencia) ? moment(acuerdoPrincipal.FechaDeAudiencia).format('DD MMMM YYYY hh:mm a') : 'Sin fecha de audiencia';
                }
            }
            cedulaObjTabla.PersonaANotificar = "Sin persona a notificar";
            if(this.campoRequeridoEsValido(cedula.PersonasANotificar) && this.campoRequeridoEsValido(cedula.PersonasANotificar[0].DatosGenerales)) {
                    const { Fisica, Moral } = cedula.PersonasANotificar[0].DatosGenerales;
                    if(this.campoRequeridoEsValido(Fisica))
                        cedulaObjTabla.PersonaANotificar = `${ Fisica.Nombre.toUpperCase().trim() } ${ (this.campoRequeridoEsValido(Fisica.ApellidoPaterno)) ? Fisica.ApellidoPaterno.toUpperCase().trim() : "" }${ (this.campoRequeridoEsValido(Fisica.ApellidoMaterno)) ? (" " + Fisica.ApellidoMaterno.toUpperCase().trim()) : "" }`; 
                    else if(this.campoRequeridoEsValido(Moral))
                        cedulaObjTabla.PersonaANotificar = `${ Moral.Nombre.trim() }`; 
            } 
            cedulaObjTabla.estatus = cedula.Estatus.Nombre;
            return cedulaObjTabla;
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para confirmacion. 
         * @param {object} notificador [asignacion que que se removera]
         * @see {@link eliminarNoticadorBD}
         */
        confirmacionPerdidaCedulasSeleccionadas: function () {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: `Se encuentran cedulas seleccionas para enviar,<br> si deseas continuar se perdera la informacion.`,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.cedulasEnvioAJuzgado = [];
                        this.obtenerCedulasParaEnvioBD();
                    }
                }
            });
        },
        campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'array' || campo instanceof Array) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo.length > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      cargarZonasRegistradas: function() {
        const SERVIDOR = api.conexion;
        const METODO_API_OBTENER = api.SINOJ.catalogos.C021TiposZonas;
        let urlApi = SERVIDOR + METODO_API_OBTENER;
        let peticionAPI = {
            ZonaId: null,
            ConInactivas: false,
            ConPoligonos: true,
            ConNotificadores: true,
            esPrueba: false
        }
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticionAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        let mensajeError = respuesta.data.Error.Mensaje;
                        console.log(mensajeError);
                        comun.mensajeDeAlerta(mensajeError, null, null);
                    } 
                    else {
                        this.zonasBD = respuesta.data.Zonas;
                        this.poligonosZonas = this.obtenerPoligonosDeZonas(this.zonasBD);
                        //console.log("ejecuto bien::zonas::",this.zonasBD);
                        //console.log("ejecuto bien::poligonos::",this.poligonosZonas);
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                }
        ); 
      },
      obtenerPoligonosDeZonas: function(zonas) {
          let polygonos = [];
          let zonasTmp = [];
          if(zonas.length > 0) {
              zonas.forEach(z => {
                  let polygono = this.polygonoDbApolygonoObj(z);
                  polygonos.push(polygono);
              });
          }
          return polygonos;
      },
      polygonoDbApolygonoObj: function(zona) {
          const polygonos = zona.Poligonos;
          let polygonoObj = {};
          let listaCoordPolygonoObj = [];
          polygonos.forEach(p => {
              let coordenadas = [p.Coordenada.Latitud, p.Coordenada.Longitud];
              listaCoordPolygonoObj.push(coordenadas);
              polygonoObj.coordenadas = listaCoordPolygonoObj;
          });
          polygonoObj.zona = zona.ZonaId;
          return polygonoObj;
      },
      asignarValoresDeUsuario: async function(areaDeUsuario) {
             // se asignan los valores del usuario (en mounted y no en created porque es hasta que este creada la instancia del componente FiltrosDeBusqueda)
            if(this.campoRequeridoEsValido(areaDeUsuario)) {
                const { AreaId } = areaDeUsuario;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.esInformativo = this.campoRequeridoEsValido(AreaId) ? true : false;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.areaId = this.campoRequeridoEsValido() ? AreaId : -1;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.key = 'CFJZVCD' + this.contRender;
                const VALOR_EVENTO = {
                    target: { value: this.campoRequeridoEsValido(AreaId) ? AreaId : -1 }
                };
                this.$refs[this.REF_FILTROS_BUSQUEDA].cambioDeArea(VALOR_EVENTO);
                
                /*  CODIGO FUNCIONAL - 14 JULIO DE 2023 -ANTES DE IMPLEMNETACION JUZGADO MIXTO
                const ES_JUZGADO_MIXTO = this.esJuzgadoMixto(this.$store.state.Login_Usuario.Area);
                if(!ES_JUZGADO_MIXTO) {
                    // se llama a funcion de evento correspondiente al catalogo de Area para que actualice los demas catalogos
                    const AREA_COMPLETA = await Promise.resolve(this.obtenerMateriaYArea({ areaId: AreaId }));
                    console.log('areaCompleta::', AREA_COMPLETA);
                    //Actualizo materia
                    this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Materia.parametros.AreaId = (this.campoRequeridoEsValido(AreaId)) ? parseInt(AreaId) : -1;
                    this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Materia.materiaId = (this.campoRequeridoEsValido(AREA_COMPLETA) && this.campoRequeridoEsValido(AREA_COMPLETA.Materias)) ? AREA_COMPLETA.Materias[0].MateriaId : -1;
                }*/

                const ES_JUZGADO_MIXTO = this.esJuzgadoMixto(this.$store.state.Login_Usuario.Area);
               
                // se llama a funcion de evento correspondiente al catalogo de Area para que actualice los demas catalogos
                const AREA_COMPLETA = await Promise.resolve(this.obtenerMateriaYArea({ areaId: AreaId }));
                console.log('areaCompleta::', AREA_COMPLETA);
                //Actualizo materia
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Materia.parametros.AreaId = (this.campoRequeridoEsValido(AreaId)) ? parseInt(AreaId) : -1;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Materia.materiaId = (this.campoRequeridoEsValido(AREA_COMPLETA) && this.campoRequeridoEsValido(AREA_COMPLETA.Materias)) ? AREA_COMPLETA.Materias[0].MateriaId : -1;
                
                this.$refs[this.REF_FILTROS_BUSQUEDA].conRenderGeneral += 33;
                this.$refs[this.REF_FILTROS_BUSQUEDA].evtDeshabilitarFiltros('Cedula');
            }
        },
        obtenerMateriaYArea: async function({ areaId }) {
          let area = null;
          try {
              const SERVIDOR = api.conexion;
              const METODO_API_OBTENER = api.PJ.catalogos.C001Areas;
              const URL_SEVICIO = SERVIDOR + METODO_API_OBTENER;
              const PETICION_API = { AreaId: areaId, conPartidoJudicial: true, conMaterias: true }; 
              let peticionArchivos = false;
              let HEADERS = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
              const RESPUESTA = await axios.post(URL_SEVICIO, PETICION_API, HEADERS);
              const DATOS = await RESPUESTA.data;
              let { SiHayError, Error, Areas } = DATOS;
              if (SiHayError) {
                  console.log(Error);
              } 
              else {
                if(this.campoRequeridoEsValido(Areas))
                  area = Areas[0];
              }
          }
          catch(excepcion) {
              console.log(excepcion);
          }
          return area;
        },
        esJuzgadoMixto: function(areaDeUsuario) { debugger
            let usuarioDeJuzgadoMixto = false;
            if(this.campoRequeridoEsValido(areaDeUsuario)) {
                const { AreaId } = areaDeUsuario;
                const JUZGADOS_MIXTOS = Object.values(enumeraciones.sinoj.juzgadosMixtos);
                if(this.campoRequeridoEsValido(JUZGADOS_MIXTOS)) {
                    usuarioDeJuzgadoMixto = JUZGADOS_MIXTOS.some(jz => jz == AreaId);
                }
            }
            return usuarioDeJuzgadoMixto;
        },
    },
    async mounted() {
        if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area)) {
            this.cargoAreaDeUsuario = true;
            await Promise.resolve(this.asignarValoresDeUsuario(this.$store.state.Login_Usuario.Area));
            this.obtenerCedulasParaEnvioBD();
        }
    },
    created() {
        this.mesajeSinCedulas = 'No se ha realizado ninguna busqueda, en el paso 1 presione el boton de Buscar.';
        this.cargarZonasRegistradas();
    },
    computed: {
        obtenerNumeroDeCedulasAEnviar() {
            return this.numeroCedulasAEnviar;
        }
    },
    watch: {
        '$store.state.Login_Usuario.Area': async function() {
            if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area) && !this.cargoAreaDeUsuario) {
                this.cargoAreaDeUsuario = true;
                await Promise.resolve(this.asignarValoresDeUsuario(this.$store.state.Login_Usuario.Area));
                this.obtenerCedulasParaEnvioBD();
            }
        },
        'cedulasEnvioAJuzgado': function() { 
            let todosLosElementosSeleccionados = (this.cedulasEnvioAJuzgado.filter(c => c.enviar).length == this.cedulasParaEnvioTabla.length);
            this.$refs[this.tablaCedulas.REF_TABLA_CEDULAS].mostrarSeleccionTodoComponentePadre(todosLosElementosSeleccionados);
        }
    }
}
</script>
<style scoped>
#inputs-filtro-memoria input {
    background-color: rgb(224, 224, 224) !important;
    color: #1b1919 !important;
}

#encabezados-tp {
    margin-bottom: 1em;
}

#encabezados-tp h1 {
    margin-bottom: 0;
    font-weight: bold;
}

#encabezados-tp h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#ffffff;
}

#contendor-principal-envioDeCedulas .card-header {
    background-color: rgb(70, 70, 70);
}

#contendor-principal-envioDeCedulas .card-body {
    background-color: rgb(49, 49, 49);
}

#contendor-principal-envioDeCedulas .card {
    border: 1px solid rgb(129, 129, 129) !important;
}

#contenedor-envioDeCedulas {
    display: flex;
}

.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}

#formulario-envio-cedula {
    display: flex;  
    justify-content: space-between;
}

.catalogo-horizontal {
    display: flex; 
    align-items: center;
    justify-content: center;
}

#contenedor-campos-informativos-enviar {
    align-items: center;
    margin-top: 2em; 
    display:flex; 
    margin-top: 2em;
    justify-content: end;
}

.contenedor-sin-cedula {
    background-color: rgb(36, 34, 34);
    height: 40px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

#encabezado-contenedor-contenido {
  background-color: rgb(44, 43, 43);
  padding: 10px;
}

.texto-ajustable {
    font-size: 1vw;
}

.contenedor-cargando {
    background-color: rgb(36, 34, 34);
    height: 40px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

#visualizador-reporte-envioJuzgado .modal-lg {
    max-width: 70% !important;
}

#visualizador-reporte-envioJuzgado .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#visualizador-fecha-envio-opciones .modal-lg {
    max-width: 20% !important;
}

#visualizador-fecha-envio-opciones .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#f-busqueda {
    width: 23vw;
}
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Cedulas/EnvioAJuzgado/CEnvioDeCedulas.vue